/**
 * Noti Api
 */

// 알림 리스트 호출
export async function getNotiList(app, wsId, listType, lastKey) {
  // console.log('setClipUpdate')
  return await app.$axios.post('/v1/noti/list', {
    wsId,
    listType,
    lastKey,
  })
}

// 알림 확인 추가
export async function setNotiWatched(app, wsId, mtId, clipId) {
  return await app.$axios.post('/v1/noti/watched', {
    wsId,
    mtId,
    clipId,
  })
}

// Assigned 카운트
export async function getAssignedCnt(app, wsId) {
  return await app.$axios.post('/v1/inbox/count', {
    wsId,
  })
}
